import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
  booleanAttribute,
  input,
} from '@angular/core';

@Component({
  selector: 'procure-label-value-list',
  templateUrl: './label-value-list.component.html',
  styleUrl: './label-value-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LabelValueList {
  readonly inExpansionPanel = input<boolean, boolean>(false, {
    transform: booleanAttribute,
  });
}
